import { hydrate, render } from 'preact';
import { isReportUrl } from './report/App';
import { initAnalytics } from './report/analytics';
import { Page } from './site/Page';
import './fonts.css';
import './styles.css';

initAnalytics();
const root = document.getElementById('app')!;
const vnode = <Page path={location.pathname} />;
// The build prerenders each page into #app (scripts/prerender.ts). Hydrate it when the first client render
// matches; a report URL starts in a different view, so it renders from scratch.
if (root.firstElementChild && !isReportUrl()) hydrate(vnode, root);
else { root.textContent = ''; render(vnode, root); }
